import { motion, AnimatePresence } from 'framer-motion';
import { X, Database, CheckCircle } from 'lucide-react';

interface CodeHubERPModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CodeHubERPModal({ isOpen, onClose }: CodeHubERPModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-teal-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-teal-500/30 shadow-2xl shadow-teal-500/20"
          >
            <div className="relative p-8 border-b border-teal-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl">
                    <Database className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-cyan-400">
                      CodeHub ERP
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Le cœur et les poumons du département</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-teal-600/20 via-cyan-600/20 to-teal-600/20 rounded-xl p-8 border-2 border-teal-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">CodeHub : Excellence Obligatoire</h3>
                <p className="text-gray-300 text-center text-lg">
                  CodeHub est l'ERP du département. <strong className="text-white">Zéro faille</strong> sur vision/temps/docs.
                </p>
              </div>
              <div className="bg-gradient-to-br from-teal-500/10 to-cyan-500/10 rounded-xl p-6 border border-teal-500/30">
                <h4 className="text-xl font-bold text-white mb-4">Fonctionnalités</h4>
                <ul className="space-y-2 text-gray-300">
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                    <span>Gestion de projets et suivi par quart</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                    <span>Documentation vivante et centralisée</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                    <span>Transparence totale pour les clients</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="p-6 border-t border-teal-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-xl hover:from-teal-600 hover:to-cyan-600 transition-all duration-200 font-semibold shadow-lg shadow-teal-500/20 hover:shadow-teal-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}












